var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfflinestep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -4,
    width: 44,
    height: 44
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_198_20366_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 24,
    height: 24,
    rx: 12,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2384 15.2313L19.0471 19.2939L17.8171 15.2313H16.8127L15.4791 19.2939L14.3863 15.2313H8.11877V16.247H10.0911V20.7686H11.3465V16.247H13.3869L14.7367 20.7686H16.0753L17.2829 17.1306L18.4235 20.7686H19.7712L21.5394 15.2313H20.2384ZM21.7954 15.2313V16.6644H23.0873V15.2313H21.7954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0072 18.0071L26.9691 16.6603H24.9865L23.9008 15.2313H25.4009C25.758 15.2303 26.111 15.3065 26.4358 15.4548C27.0926 15.7483 27.615 16.2779 27.8994 16.9386C28.045 17.2713 28.1197 17.6307 28.1188 17.9939C28.1195 18.3583 28.0448 18.719 27.8994 19.0532C27.7665 19.3673 27.5787 19.6551 27.3448 19.9033L26.0072 18.0071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0044 20.7645L25.085 19.4371L27.0787 20.148C26.8829 20.3074 26.6671 20.4405 26.4369 20.5441C26.1116 20.6923 25.7583 20.7685 25.4009 20.7676L24.0044 20.7645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7954 20.7645V17.3886L23.1543 18.3514L23.1523 20.7645H21.7954Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_198_20366_clip_path",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflinestep2);
export default __webpack_public_path__ + "static/media/offlinestep2.71814287a24c2e9b6afa701bc7f7cfc5.svg";
export { ForwardRef as ReactComponent };